import * as tslib_1 from "tslib";
import React, { useMemo } from 'react';
import _ from 'lodash';
import { useSign, formatNumber } from '../../lib';
const NumberView = ({ value, currency, roundDecimal, format, integer, locale, percent, prefix, greeks, isStrikeField, precisionOverride, isShareField, }) => {
    const num = useMemo(() => formatNumber(value, {
        currency,
        roundDecimal,
        format,
        integer,
        locale,
        percent,
        prefix,
        greeks,
        isStrikeField,
        precisionOverride,
        isShareField,
    }), [
        value,
        currency,
        roundDecimal,
        format,
        integer,
        locale,
        percent,
        prefix,
        greeks,
        isStrikeField,
        precisionOverride,
        isShareField,
    ]);
    return React.createElement(React.Fragment, null, num);
};
const BoldNumberView = props => (React.createElement("strong", null,
    React.createElement(NumberView, Object.assign({}, props))));
const SignedNumberView = (_a) => {
    var { bold, hideIcon, hidePrefix, precisionOverride } = _a, props = tslib_1.__rest(_a, ["bold", "hideIcon", "hidePrefix", "precisionOverride"]);
    const [, changeUi] = useSign(_.toNumber(props.value));
    return (React.createElement("span", { className: changeUi.className },
        changeUi.icon && !hideIcon && React.createElement("i", { className: changeUi.icon }),
        ' ',
        bold ? (React.createElement(BoldNumberView, Object.assign({ precisionOverride: precisionOverride, prefix: !hidePrefix ? changeUi.prefix : null }, props))) : (React.createElement(NumberView, Object.assign({ precisionOverride: precisionOverride, prefix: !hidePrefix ? changeUi.prefix : null }, props)))));
};
export const SignedNumberContainer = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const [, changeUi] = useSign(_.toNumber(props.value));
    return React.createElement("span", { className: changeUi.className }, children);
};
export const Number = React.memo(NumberView);
export const BoldNumber = React.memo(BoldNumberView);
export const SignedNumber = React.memo(SignedNumberView);
//# sourceMappingURL=Number.js.map